import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import OptionsContainer from '../../../../components/OptionsContainer';

const RadioInput = ({
  name,
  value,
  checked,
  onChange,
  disabled,
  message,
}) => (
  <OptionsContainer>
    <input
      disabled={disabled}
      type="radio"
      name={name}
      value={value}
      checked={checked}
      onChange={onChange}
    />
    <FormattedMessage {...message} />
  </OptionsContainer>
);

RadioInput.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  message: PropTypes.object.isRequired,
};

RadioInput.defaultProps = {
  disabled: false,
};

export default RadioInput;



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepDeclaration/components/SubmitClaim/components/RadioInput.js